const CATEGORY_ACTION_TYPES = {
  LOAD_CATEGORY: 'category/LOAD_CATEGORY',
};

export default CATEGORY_ACTION_TYPES;
